// Заглушка для типа, которого студия не рисует: легаси `button`/`divider`/`animation`
// (в юнион они не входят, но бек их всё ещё принимает и старые данные ими полны).
// Молчаливый `null` делал из такого элемента фантом — пустую полосу, которую нельзя
// настроить, но которая ест лимит элементов и уезжает обратно в PUT.
// Канвас всегда белый, а тема приложения тёмная — цвета только из blockTheme.
import { useMessages } from '@/i18n'
import { messages } from './messages'
import { HelpCircle } from 'lucide-react'
import { blockTheme, hsl } from '@teach/ui'

interface Props {
  type: string
  /** Прохождение: плеер академии на неизвестном типе рисует `null` — заглушка
   *  с именем типа авторская, ученик её не увидит никогда. */
  isRun?: boolean
}

export const UnsupportedElement = ({ type, isRun }: Props) => {
  const m = useMessages(messages)
  if (isRun) return null
  return (
    <div
      data-testid="design-unsupported"
      className="flex w-full items-center justify-center gap-2 rounded-lg border-2 border-dashed px-3 py-4 text-xs"
      style={{ borderColor: hsl(blockTheme.muted), color: hsl(blockTheme.foreground, 0.5) }}
    >
      <HelpCircle className="h-4 w-4 shrink-0" />
      <span>{m.unsupported(type)}</span>
    </div>
  )
}
